import { useSnapshot } from 'valtio';

import TextNew from '@cartwhl/ui/base/TextNew';

import { userStore } from 'stores/global';

import { isAssetLibrarySubView } from '../assetLibraryView';
import { useStore } from '../assetLibraryStore';
import { getAssetLibraryCaption, getAssetLibraryTitle } from '../utils';
import AssetLibrarySubViewHeader from './AssetLibrarySubViewHeader';
import AssetLibraryViewNavButtons from './AssetLibraryViewNavButtons';

export default function AssetLibraryPageHeader() {
  const store = useStore();
  const { libraryView } = store.state;
  const { organizationInfo } = useSnapshot(userStore.state);

  if (isAssetLibrarySubView(libraryView)) {
    return <AssetLibrarySubViewHeader />;
  }

  const title = getAssetLibraryTitle(organizationInfo?.planType);
  const caption = getAssetLibraryCaption(organizationInfo?.planType);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <TextNew
          as="h1"
          token="display/20/medium"
          leading="body"
          className="text-primary shrink-0 text-pretty"
        >
          {title}
        </TextNew>
        <AssetLibraryViewNavButtons />
      </div>
      <TextNew token="14/medium" className="text-tertiary pt-2 text-pretty">
        {caption}
      </TextNew>
    </div>
  );
}
